import { useState } from 'react';

import { getDecarbonizationPotentials } from '@eneco/dc/services/DecarbonizationService';
import useDC from '@eneco/dc/useDC';
import {
  DC_Products_Client_Old_Client_Models_BuildingCategory,
  DC_Products_Client_Old_Client_Models_BuildingSubCategory,
  DC_Products_Client_Old_Client_Models_ConstructionPeriod,
  DC_Products_Client_Old_Client_Models_CurrentHeatingSystem,
  DC_Products_Client_Old_Client_Models_FloorAreaM2,
  DC_Products_Client_Old_Client_Models_NumberFloors,
} from '@monorepo-types/dc';

export const useGetDecarbonizationPotential = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { businessUnit, label } = useDC();

  const get = async ({
    buildingCategory,
    buildingSubCategory,
    floorAreaM2,
    numberOfFloors,
    constructionPeriod,
    currentHeatingSystem,
    solarPanelsInstalled,
    roofIsolationInstalledWithinLast10Years,
  }: {
    buildingCategory: DC_Products_Client_Old_Client_Models_BuildingCategory;
    buildingSubCategory: DC_Products_Client_Old_Client_Models_BuildingSubCategory;
    floorAreaM2: DC_Products_Client_Old_Client_Models_FloorAreaM2;
    numberOfFloors: number;
    constructionPeriod: DC_Products_Client_Old_Client_Models_ConstructionPeriod;
    currentHeatingSystem: DC_Products_Client_Old_Client_Models_CurrentHeatingSystem;
    solarPanelsInstalled: boolean;
    roofIsolationInstalledWithinLast10Years: boolean;
  }) => {
    setIsLoading(true);
    try {
      const response = await getDecarbonizationPotentials({
        businessUnit,
        label,
        buildingCategory,
        buildingSubCategory,
        floorAreaM2,
        numberOfFloors: (+numberOfFloors > 12
          ? 'MoreThanTwelve'
          : `${numberOfFloors}`) as DC_Products_Client_Old_Client_Models_NumberFloors,
        constructionPeriod,
        currentHeatingSystem,
        solarPanelsInstalled,
        roofIsolationInstalledWithinLast10Years,
      });
      setIsLoading(false);
      return response;
    } catch (error: unknown) {
      setIsLoading(false);
      setError(error instanceof Error ? error.message : 'Failed to get the decarbonization potential');
      return undefined;
    }
  };

  return {
    get,
    isLoading,
    error,
  };
};
